import axios from 'axios';

import store from '@/store';



// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 10000, // request timeout
});

// request interceptor
service.interceptors.request.use(
  (serviceConfig) => {

    const LogsData = store.getters['logs/getLogValue']


    serviceConfig.data = {
      ...LogsData, ...serviceConfig.data
    };
    // console.log(serviceConfig.data)
    return serviceConfig;
  },
  (error) => {
    Promise.reject(error);
  },
);

// respone interceptor
service.interceptors.response.use(
  (response) => {
    // const res = response.data;

    return response;
  },
  (error) => {
    // alert(error.message)
    return Promise.resolve(error);
  },
);

export default service;
